let protocol = window.location.protocol;
let API_URL, URL_Vicidial;
let API_URL_KALEL;
if (protocol === 'https:') {
    API_URL = 'https://crm-api.zetatecno.com/api';
    URL_Vicidial = 'https://vdqub1ovhweb.zetatecno.com/agc/api.php';
} else {
    API_URL = 'https://crm-api.zetatecno.com/api';

    //API_URL = 'http://localhost:9000/api';
    URL_Vicidial = 'https://vdqub1ovhweb.zetatecno.com/agc/api.php';
}

export { API_URL, URL_Vicidial ,API_URL_KALEL};
